module.exports = require("@wix/wix-ui-santa/editorComponentsData.bundle.min");;